import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Select from 'react-select';
import { defaultDaysForSlot } from './slotOverrides';
import {
  FieldLabel,
  GhostButton,
  ModalActions,
  ModalBackdrop,
  ModalBody,
  ModalCard,
  ModalTitle,
  NumberInput,
  PrimaryButton,
  ToggleLabel,
  ToggleRow,
  ToggleSwitch,
  reactSelectStyles,
} from './styles';

export default function SlotEditorModal({
  slotFmt,
  slot,
  existingOverride,
  shelfLife,
  plannedItemsBySlot,
  menuVendItemOptions,
  onSave,
  onClear,
  onCancel,
}) {
  const defaultDays = defaultDaysForSlot(
    slotFmt,
    plannedItemsBySlot,
    shelfLife,
    slot,
  );
  const currentBaseline = plannedItemsBySlot && plannedItemsBySlot[slotFmt];
  const baselineFirst =
    currentBaseline && (currentBaseline.itemsInSlot || [])[0];
  const baselineVendItem =
    (baselineFirst && baselineFirst.vendItemName) || slot.vendItemName || '';
  const baselineCount = currentBaseline
    ? currentBaseline.itemsInSlot.length
    : 0;

  const [empty, setEmpty] = useState(existingOverride?.empty || false);
  const [vendItemName, setVendItemName] = useState(
    existingOverride?.vendItemName || '',
  );
  const [count, setCount] = useState(
    existingOverride?.count != null ? String(existingOverride.count) : '',
  );
  const [days, setDays] = useState(
    existingOverride?.daysUntilExpiration != null
      ? String(existingOverride.daysUntilExpiration)
      : '',
  );

  const disabled = empty;

  const submit = () => {
    const override = {};
    if (empty) {
      onSave({ empty: true });
      return;
    }
    if (vendItemName.trim()) override.vendItemName = vendItemName.trim();
    if (count !== '' && !Number.isNaN(Number(count))) {
      override.count = Number(count);
    }
    if (days !== '' && !Number.isNaN(Number(days))) {
      override.daysUntilExpiration = Number(days);
    }
    // If nothing changed, treat as a clear to keep state minimal.
    if (Object.keys(override).length === 0) {
      onClear();
      return;
    }
    onSave(override);
  };

  return ReactDOM.createPortal(
    <ModalBackdrop onClick={onCancel}>
      <ModalCard onClick={(e) => e.stopPropagation()}>
        <ModalTitle>Edit slot {slotFmt}</ModalTitle>
        <ModalBody>
          Overrides here are layered on top of the selected fill mode. Leave a
          field blank to keep the fill-mode default.
        </ModalBody>

        <ToggleRow
          onClick={(e) => {
            e.preventDefault();
            setEmpty((v) => !v);
          }}
        >
          <ToggleSwitch on={empty} />
          <ToggleLabel>
            Empty this slot
            <small>
              Forces the slot to have zero items, regardless of the other
              fields.
            </small>
          </ToggleLabel>
        </ToggleRow>

        <FieldLabel>VendItem</FieldLabel>
        <Select
          value={
            vendItemName ? { value: vendItemName, label: vendItemName } : null
          }
          options={menuVendItemOptions}
          styles={reactSelectStyles}
          isDisabled={disabled}
          isClearable
          isSearchable
          placeholder={baselineVendItem || 'keep current'}
          onChange={(opt) => setVendItemName(opt ? opt.value : '')}
        />

        <FieldLabel>Count</FieldLabel>
        <NumberInput
          type="number"
          min="0"
          value={count}
          placeholder={`default: ${baselineCount}`}
          disabled={disabled}
          onChange={(e) => setCount(e.target.value)}
        />

        <FieldLabel>Days until expiration</FieldLabel>
        <NumberInput
          type="number"
          value={days}
          placeholder={`default: ${defaultDays}`}
          disabled={disabled}
          onChange={(e) => setDays(e.target.value)}
        />

        <ModalActions>
          {existingOverride && (
            <GhostButton onClick={onClear}>Clear override</GhostButton>
          )}
          <GhostButton onClick={onCancel}>Cancel</GhostButton>
          <PrimaryButton onClick={submit}>Save override</PrimaryButton>
        </ModalActions>
      </ModalCard>
    </ModalBackdrop>,
    document.body,
  );
}
